import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import toast from "react-hot-toast";
import {  SUMMARY_DOCUMENT } from "src/config/apiConfig";

// Fetch summary documents
export const getSummaryDocumentsThunk = createAsyncThunk(
    'document/getSummaryDocumentsThunk',
    async (
        {
            pageNumber,
            pageSize,
            sortBy = 'Id', 
            sortOrder = 'asc',
            query = ''
        }: {
            pageNumber: number;
            pageSize: number;
            sortBy?: string;
            sortOrder?: string;
            query?: string
        },
        thunkAPI) => {
        try {
            const accessToken = localStorage.getItem('userToken');
            const headers = accessToken ? { Authorization: `Bearer ${accessToken}` } : {};

             // Transform sortBy to camelCase where the first letter is uppercase
             const formattedSortBy = sortBy.charAt(0).toUpperCase() + sortBy.slice(1);

            const response = await axios.get(`${SUMMARY_DOCUMENT}`, {
                params: {
                    PageNumber: pageNumber,
                    PageSize: pageSize,
                    SortBy: formattedSortBy,
                    SortOrder: sortOrder,
                    Query: query
                },
                headers: {
                    ...headers,
                },
            });

            console.log(response)
            if (response.status === 200) {
                return response.data;
            } else {
                toast.error('Failed to fetch summary documents');
                return thunkAPI.rejectWithValue('Failed to fetch summary documents');
            }
        } catch (error: any) {
            toast.error(error.response?.data?.message || 'An error occurred while fetching documents');
            return thunkAPI.rejectWithValue(error.message);
        }
    }
);
